<template>
  <Chart type="pie" :height="height" :data="data" />
</template>

<script>
import { defineComponent, computed } from 'vue'
export default defineComponent({
  props: {
    height: {
      type: Number,
      default: 0
    },
    results: { type: Array, default: () => [] },
    colors: { type: Array, default: () => [] }
  },
  setup(props) {
    const data = computed(() => {
      return {
        labels: ['Buena', 'Regular', 'Mala'],
        datasets: [
          {
            data: props.results,
            backgroundColor: props.colors,
            hoverBackgroundColor: props.colors,
            borderWidth: 5,
            borderColor: '#fff'
          }
        ]
      }
    })

    return {
      data
    }
  }
})
</script>
